import classNames from "classnames";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { ButtonPagueDefault } from "../../styles/primeReactConfig";

export default function DialogTermo({ close, aceiteTermo }) {
  const [checkedTermo, setCheckedTermo] = useState(false);
  const [viewTermo, setViewTermo] = useState(true);

  const termoFooter = (
    <div className="grid justify-center w-full h-[10vh] ">
      <div className="mb-2 h-full" style={{ textAlign: "center" }}>
        <Checkbox
          inputId="binary"
          checked={checkedTermo}
          onChange={(e) => setCheckedTermo(e.checked)}
        />
        <label htmlFor="binary" style={{ marginLeft: "5px" }}>
          Concordo com os presentes Termos de Uso e Política de Privacidade
        </label>
      </div>
      <div className="w-full grid h-full">
        <Button
          className="w-full"
          label="Continuar"
          pt={ButtonPagueDefault}
          onClick={() => { aceiteTermo(); close() }}
          disabled={!checkedTermo}>
        </Button>
      </div>
    </div>
  );

  return (
    <Dialog
      visible
      draggable={true}
      maximizable
      onHide={() => close()}
      header="Contrato de Uso da Plataforma"
      pt={{
        root: ({ state }) => ({
          className: classNames('rounded-lg shadow-lg border-0', 
            'max-h-screen transform scale-100',
            'm-0 w-[90vw]',
            'dark:border dark:border-blue-900/40', {
            'transition-none transform-none !w-screen !h-screen !max-h-full !top-0 !left-0': state.maximized
          })
        }),
        header: classNames('flex items-center justify-between shrink-0',
          'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
          'dark:bg-gray-900  dark:text-white/80 h-[10vh]'),
        content: ({ state }) => ({
          className: classNames('overflow-auto w-full h-[72vh]',
            'bg-white text-gray-700 px-6 pb-8 pt-0',
            //'rounded-bl-lg rounded-br-lg',
            'dark:bg-gray-900 dark:text-white/80 ', {
            "grow h-[78vh]": state.maximized
          })
        }),
        footer: {
          className: classNames('shrink-0 ', 
            'h-[12vh]',
            'border-t-0 bg-white text-gray-700 text-right rounded-b-lg', 
            'dark:bg-gray-900  dark:text-white/80')
        },
      }}
      //className="boletosDialog"
      footer={termoFooter}
    >
      <div className="flex justify-content-center h-full w-full">
        <div onClick={() => setViewTermo(prevView => !prevView)}
          style={{ height: 'auto', width: '4vh', backgroundColor: "lightgray", display: "grid", alignContent: "center", cursor: "pointer" }}>
          <span style={{ height: "100%", display: "grid", alignContent: "center" }} >
            <BiChevronLeft className="text-4xl"/>
          </span>
        </div>
        {viewTermo ?
          <iframe
            title="Termos de Uso"
            src = {'/V11_Máquina de vendas_22.06.26.pdf'} // src={'/V10_Máquina de vendas_04_06_25.pdf'}
            width={'100%'}
            height={"auto"}
          />
          :
          <iframe
            title="Política de Privacidade"
            src={'/POLITICA_DE_PRIVACIDADE.pdf'}
            width={'100%'}
            height={"auto"}
          />
        }
        <div onClick={() => setViewTermo(prevView => !prevView)}
          style={{ height: 'auto', width: '4vh', backgroundColor: "lightgray", display: "grid", alignContent: "center", cursor: "pointer" }}>
          <span style={{ height: "35vh", display: "grid", alignContent: "center" }} >
            <BiChevronRight className="text-4xl" />
          </span>
        </div>
      </div>
    </Dialog>
  )
}